module.exports = __webpack_public_path__ + "static/media/Rock_08_UV_H_CM_1.da494a88.jpg";